export enum EditDialog {
    ReleasedDateForm = 'ReleasedDateForm',
    ReleaseAll = 'ReleaseAll',
    BulkAdjustAvailabilities = 'BulkAdjustAvailabilities',
}
